/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

// TODO: This needs reviewing - TJ, 11.9.2013
(function($) {
	"use strict";
	/*globals Tc, debug */
	/**
	 * Hidden component which values gets initialized by a GET query parameter.
	 *
	 * @author Stefan Maurer
	 * @namespace Tc.Module
	 * @class HiddenGetParameter
	 * @extends Tc.Module
	 */
	Tc.Module.HiddenGetParameter = Tc.Module.extend({

		/**
		 * Main hook.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$input = $ctx.find('input'),
				paramName = $input.data('param');

			if (paramName !== undefined && paramName.length) {
				var regex = new RegExp(paramName + '=([^&]+)');
				var m = location.search.match(regex),
					getParamValue = m && m[1] && decodeURIComponent(m[1]);

				if (getParamValue !== null && getParamValue.length) {
					$input.val(getParamValue);
				}

				debug.log("Tc.Module.HiddenGetParameter > on", paramName, getParamValue);
			}

			callback();
		}

	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/modules/Tc.Module.HiddenGetParameter.js
// module id = 279
// module chunks = 0